import Flickity from 'flickity';

export default {
  init($element) {

  },
  finalize($element) {

    const logosCarousel = new Flickity($element.find('.scrolling-logos-wrap').get()[0], {
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'center',
      wrapAround: true,
      autoPlay: 3000,
      pauseAutoPlayOnHover: false,
      on: {
        ready: function() {
          window.dispatchEvent(new Event('resize')); // Quickfix for sizing issue
        },
      },
    });

  },
}


// WEBPACK FOOTER //
// ./scripts/partials/ssg/scrollingLogos.js